import {
  MenuItemContent,
  type MenuItemContentProps,
} from '@components/Menu/MenuItemContent.tsx';
import { classNames } from '@utils/classNames.ts';
import { type HTMLAttributeAnchorTarget } from 'react';
import { NavLink } from 'react-router-dom';

export const LinkMenuItem = ({
  href,
  className,
  target,
  showLabel,
  labelId,
  ...menuItemProps
}: {
  href: string;
  className?: string;
  target?: HTMLAttributeAnchorTarget;
} & Omit<MenuItemContentProps, 'isActive'>) => {
  return (
    <NavLink
      to={href}
      className={() =>
        classNames(
          'menuitem box-slate-300 h-12',
          'bg-transparent',
          'group flex items-center pointer-events-auto rounded-xl gap-1',
          showLabel ? 'sm:w-full' : '',
          className,
        )
      }
      aria-labelledby={labelId}
      target={target}
    >
      {({ isActive }) =>
        MenuItemContent({
          labelId,
          isActive,
          showLabel,
          ...menuItemProps,
        })
      }
    </NavLink>
  );
};
